import { useAppTranslation } from '@hooks/useAppTranslation';
import { useSharedStackScreenOptions } from '@hooks/useSharedStackScreenOptions';
import { Stack } from 'expo-router';

export default function ReportsLayout(): React.ReactNode {
  const { t } = useAppTranslation();
  const screenOptions = useSharedStackScreenOptions();

  return (
    <Stack screenOptions={screenOptions}>
      <Stack.Screen
        name="index"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="[reportId]"
        options={{
          headerTitle: t('reports.detailTitle', 'Report details'),
        }}
      />
      <Stack.Screen
        name="[reportId]/edit/index"
        options={{
          headerTitle: t('reportCreation.editTitle'),
        }}
      />
      <Stack.Screen
        name="[reportId]/edit/similar/index"
        options={{
          headerTitle: t('reportCreation.similarReports.title'),
        }}
      />
      <Stack.Screen
        name="[reportId]/edit/version-note/index"
        options={{
          headerTitle: t('reportCreation.versionNote.title'),
        }}
      />
      <Stack.Screen
        name="[reportId]/edit/species/index"
        options={{
          headerTitle: t('speciesSearch.title'),
        }}
      />
      <Stack.Screen
        name="[reportId]/edit/species/ai"
        options={{
          headerTitle: t('speciesSearch.ai.title'),
        }}
      />
      <Stack.Screen
        name="[reportId]/edit/species/taxonomy"
        options={{
          headerTitle: t('speciesSearch.taxonomy.title'),
        }}
      />
      <Stack.Screen
        name="[reportId]/edit/request-rra/success"
        options={{
          headerShown: false,
        }}
      />
    </Stack>
  );
}
